
export const ENV_CURRENT_DOMAIN = process.env.NODE_ENV == 'development' ? process.env.VUE_APP_URL : location.hostname.split('.').slice(-2).join('.');
export const ENV_API_URL = process.env.VUE_APP_API_URL.replace('{CLIENT}', ENV_CURRENT_DOMAIN);
export const ENV_CDN_URL = process.env.VUE_APP_CDN_URL.replace('{CLIENT}', ENV_CURRENT_DOMAIN);
export const ENV_SOCKET_URL = process.env.VUE_APP_SOCKET_URL.replace('{CLIENT}', ENV_CURRENT_DOMAIN);
export const ENV_JACKPOT_SOCKET_URL = process.env.VUE_APP_JACKPOT_SOCKET_URL;